// import _ from 'lodash';
import React, { useState, useEffect } from "react";
// import { fetchCustomerListApi } from "../services/CustomerService";
// import api_user_filter from './api_user_filter';
// import api_customer_loyalty from './api_customer_loyalty';
// import api_customer_loyalty_filter from './api_customer_loyalty_filter';
import useToken from '../../Components/useToken';
import * as CustomerApi from '../../Services/CustomerApi'

export const CustomerContext = React.createContext({
  customerListLoading: false,
  customerList: [],
  isDataLoading: false,
  setIsDataLoading : () => {}
});

// async function getCustomerData(id, context, token) {
//   const customerData = await CustomerApi.getCustomerById(id, token);
//   console.log({ getCustomerById: { id, customerData, list : context.customerList, token : context.token } })
//   return Promise.resolve(customerData);
// }        


async function fetchCustomerListApi(token) {
  return await CustomerApi.getUserList(token);
}


export const CustomerProvider = ({ children }) => {
  const [customerList, setCustomerList] = useState([]);
  const [customerListLoading, setPageLoading] = useState(false);
  const { token } = useToken();

  useEffect(() => {
    const getCustomers = async () => {
      setPageLoading(true)
      const data = await fetchCustomerListApi(token);
      setCustomerList(data)
      setPageLoading(false)
    }
    getCustomers()
  }, [token])

  const [isDataLoading, setIsDataLoading] = useState(false);




  return (<CustomerContext.Provider value={{
    customerListLoading,
    customerList,
    setCustomerList,
    loadCustomerId(id) {

    },
    isDataLoading,
    setIsDataLoading : (val) => { 
      console.log('MEX set loading ', val);
      setIsDataLoading(val);
    }
  }}>
    {children}
  </CustomerContext.Provider>)
}